import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import 'url-polyfill'; // This polyfill adds support URL API for IE
import ReactModal from 'react-modal';
import createRouter from 'src/js/router/helpers/create-router';
import error from 'src/js/modules/error';
import store from './store';
import App from './app';
import initApp from './init-app';

/*
  In order to prevent tracking redundant errors with "Network error"
  message we need to establish global variable on "beforeunload" event
  and use it in "errorHandler" middleware to prevent tracking such error
*/
window.addEventListener('beforeunload', () => {
  // eslint-disable-next-line no-underscore-dangle
  window._ws_resources_unloaded = true;
});

ReactModal.setAppElement('#app');

initApp().then(() => {
  const router = createRouter();
  const root = createRoot(document.getElementById('app'));

  root.render(
    <Provider store={store}>
      <App router={router} />
    </Provider>
  );
});

error.operations.registerCatcher(error.helpers.errorCatcher);
